import type React from 'react';
import { useEffect, useLayoutEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router';

import { isInWebView } from '@/components/Client/shared/webview';
import { Languages, SUPPORTED_LANGUAGES } from '@/constants';

interface IProps {
  children: React.ReactNode;
}

const LanguageGuard: React.FC<IProps> = ({ children }) => {
  const { lang } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const supportedLngs = useMemo(
    () => i18n.options.supportedLngs || SUPPORTED_LANGUAGES,
    [i18n.options.supportedLngs]
  );

  useLayoutEffect(() => {
    if (isInWebView()) return;
    if (lang && !supportedLngs.includes(lang)) {
      const newPath =
        location.pathname.replace(`/${lang}/`, `/${Languages.kz}/`) +
        location.search;
      navigate(newPath, { replace: true });
    } else if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
  }, [location, lang, i18n, supportedLngs]);

  // Настройки языка документа для SEO
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return children;
};

export default LanguageGuard;
